module.exports = __webpack_public_path__ + "img/icon17.e153e115.png";